<template>
  <b-card id="generate-report" no-body class="container-card px-1 py-2 pb-3">
    <b-row>
      <b-col cols="12" md="6">
        <div class="header px-1">
          {{ "Report" }}
        </div>
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <!-- <b-table
              :key="`key-${keyChange}`"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              :select-mode="'single'"
              :fields="fields"
              :items="reportList"
              :busy="loading.tableData"
              class="report-table default-static-table"
              :class="{ 'loading-table': loading.tableData }"
              @row-clicked="onSelectReport"
            > -->
            <b-table
              :key="`key-${keyChange}`"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              :select-mode="'single'"
              :fields="fields"
              :items="reportList"
              :busy="loading.tableData"
              class="report-table default-static-table-vertical"
              :class="{ 'loading-table': loading.tableData }"
              @row-clicked="onSelectReport"
            >
              <template #cell(report_detail)="data">
                <span v-if="data.item.report_detail">{{
                  data.item.report_detail
                }}</span>
                <span v-else>{{ "-" }}</span>
              </template>
              <template #cell(actions)="data">
                <button
                  v-b-tooltip.hover
                  title="Filter"
                  class="filter-button"
                  :class="{ active: data.item.selected }"
                  @click="onSelectReport(data.item, data.index)"
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <filter-icon class="filter-icon" />
                  </div>
                </button>
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
        <div>
          <pagination-with-reorder
            :pagination="pagination"
            @pageChange="onPageChange"
          />
        </div>
      </b-col>
      <b-col cols="12" md="6">
        <div class="container-card filter-card p-2 mb-1">
          <overlay-loading :loading="loading.generateReport">
            <template #content>
              <div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="header">
                    {{ "Filter" }}
                  </div>
                  <b-button
                    v-if="isAdjusted"
                    :variant="selectedReport.payload ? 'primary' : 'secondary'"
                    :disabled="selectedReport.payload ? false : true"
                    :class="{
                      active: selectedReport.payload
                        ? selectedReport.payload.filters
                          ? true
                          : false
                        : false,
                    }"
                    @click="generateReport(selectedReport.payload)"
                  >
                    <div class="d-flex align-items-center">
                      <span> {{ "Generate" }}</span>
                    </div>
                  </b-button>
                </div>
              </div>
              <div
                class="fields-container"
                :class="{
                  empty: selectedReport.payload
                    ? selectedReport.payload.filters
                      ? false
                      : true
                    : true,
                }"
              >
                <img
                  v-if="
                    selectedReport.payload
                      ? selectedReport.payload.filters
                        ? false
                        : true
                      : true
                  "
                  :src="EmptyFilterImage"
                  class="empty-filter"
                />
                <div v-else>
                  <b-row class="d-flex align-items-center">
                    <b-col
                      v-for="field in selectedReport.payload.filters"
                      :key="`row-${field.seq}`"
                      :cols="12"
                      :sm="field.field_property.half_size ? 6 : 12"
                    >
                      <component
                        class="custom-field"
                        :ref="`${field.key}`"
                        :is="resolveFields(field)"
                        :fieldProperties="field"
                        :key="field.key"
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </template>
          </overlay-loading>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import useGenerateReport from "./hooks/useGenerateReport";

import FilterIcon from "@/@core/components/svg/common/Filter.vue";
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue";
import Textbox from "@/views/components/dynamic-fields/components/TextBoxField.vue";
import TextAreaField from "@/views/components/dynamic-fields/components/TextAreaField.vue";
import Dropdown from "@/views/components/dynamic-fields/components/DropdownField.vue";
import DatePicker from "@/views/components/dynamic-fields/components/DatePickerField.vue";
import EmptyFilterImage from "@/assets/images/artwork/filter-img.png";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";

export default {
  components: {
    CardNoItem,
    FilterIcon,
    Toggle,
    Textbox,
    TextAreaField,
    Dropdown,
    DatePicker,
    PaginationWithReorder,
    OverlayLoading,
  },
  props: {
    isAdjusted: {
      type: Boolean,
      default: false,
    }
  },
  setup() {
    const {
      fields,
      reportList,
      selectedReport,
      loading,
      keyChange,
      pagination,
      onSelectReport,
      generateReport,
      resolveFields,
      onPageChange,
    } = useGenerateReport();

    return {
      fields,
      reportList,
      selectedReport,
      EmptyFilterImage,
      loading,
      keyChange,
      pagination,
      resolveFields,
      onSelectReport,
      generateReport,
      onPageChange,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/report/generate-report.css";
@import "~@/assets/css/pages/default-static-table.css";

.custom-field {
  width: 50%;
}
</style>
